<script lang="ts">
  import Tab from "../../../components/Tab/Tab.svelte";
  import Tabs from "../../../components/Tab/Tabs.svelte";
  import QualityLayout from "../../../layout/QualityLayout.svelte";
  import QualityDocumentManager from "../../QualityDocument/QualityDocumentManager.svelte";

  enum QualityTrainingPage {
    Personale = 1,
    VerificaFormatori,
  }

  let currentTab: QualityTrainingPage = QualityTrainingPage.Personale;
</script>

<QualityLayout>
  <div class="quality-training-main-controls">
    <div class="training-tabs">
      <Tabs>
        <Tab
          label="Formazione Personale"
          active={currentTab == QualityTrainingPage.Personale}
          on:click={(_) => {
            currentTab = QualityTrainingPage.Personale;
          }}
        />
        <Tab
          label="Verifica Formatori"
          active={currentTab == QualityTrainingPage.VerificaFormatori}
          on:click={(_) => {
            currentTab = QualityTrainingPage.VerificaFormatori;
          }}
        />
      </Tabs>
    </div>
  </div>

  {#if currentTab == QualityTrainingPage.Personale}
    <QualityDocumentManager entityName="formazione" clfDocTypeCode="FORMAZIONE" withVersion={false} />
  {/if}
  {#if currentTab == QualityTrainingPage.VerificaFormatori}
    <h1 class="title">Verifica Formatori</h1>
    <p>Funzionalità non ancora realizzata.</p>
  {/if}
</QualityLayout>

<style>
  .quality-training-main-controls {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }
  .quality-training-main-controls .training-tabs {
    flex: 1;
  }
</style>
